import { jsx as _jsx } from "react/jsx-runtime";
import { PageWrapper } from 'libs.react';
import { ChartsDashboard } from '../../components/charts_dashboard/charts_dashboard.component';
const ChartsDashboardPage = () => {
    return (_jsx(PageWrapper, { children: _jsx(ChartsDashboard, {}) }));
};
export default ChartsDashboardPage;
